import { type FC } from 'react';
import { format } from 'date-fns';
import type { ShowInfoByIdResponse, VenueInfoResponse } from '../../models/show.interface';
import { DayGroup } from './DayGroup';

interface EventsListProps {
  showInfo: ShowInfoByIdResponse | null;
  venueInfo: VenueInfoResponse | null;
  showAll: boolean;
  handleSelectDate: (date: string, time: string, eventId: number) => void;
}

export const EventsList: FC<EventsListProps> = ({
  showInfo,
  venueInfo,
  showAll,
  handleSelectDate,
}) => {
  // Подготовка данных о событиях
  const getEventsData = () => {
    const events = (showInfo?.events || [])
      .slice()
      .sort((a, b) => new Date(a.from).getTime() - new Date(b.from).getTime());

    // Ограничение количества отображаемых событий
    const visible = showAll ? events : events.slice(0, 8);

    // Группировка по датам
    const groups = new Map<string, { date: Date; items: typeof events }>();
    for (const ev of visible) {
      const d = new Date(ev.from);
      const key = format(d, 'yyyy-MM-dd');
      if (!groups.has(key)) groups.set(key, { date: d, items: [] });
      groups.get(key)!.items.push(ev);
    }

    return Array.from(groups.values());
  };

  const eventGroups = getEventsData();
  if (!eventGroups.length) return null;

  return (
    <div className="divide-y md:divide-y-0 bg-surface-card">
      {eventGroups.map(group => (
        <DayGroup
          key={format(group.date, 'yyyy-MM-dd')}
          date={group.date}
          events={group.items}
          venueInfo={venueInfo}
          handleSelectDate={handleSelectDate}
        />
      ))}
    </div>
  );
};
